import { create } from 'zustand';
import { apiClient } from '../services/api';

const useIngredientStore = create((set, get) => ({
  ingredients: [],
  loading: false,
  error: null,

  fetchIngredients: async () => {
    set({ loading: true, error: null });
    try {
      const data = await apiClient.get('/api/v1/ingredients');
      set({ ingredients: data, loading: false });
    } catch (error) {
      console.error('Error fetching ingredients:', error);
      set({ error: error.message, loading: false });
    }
  },

  createIngredient: async (ingredientData) => {
    set({ loading: true, error: null });
    try {
      const data = await apiClient.post('/api/v1/ingredients', ingredientData);
      set(state => ({ 
        ingredients: [...state.ingredients, data],
        loading: false
      }));
      return data;
    } catch (error) {
      console.error('Error creating ingredient:', error);
      set({ error: error.message, loading: false });
      throw error;
    }
  },

  updateIngredient: async (ingredientId, ingredientData) => {
    set({ loading: true, error: null });
    try {
      const data = await apiClient.put(`/api/v1/ingredients/${ingredientId}`, ingredientData);
      set(state => ({
        ingredients: state.ingredients.map(ingredient => 
          ingredient.id === ingredientId ? data : ingredient
        ),
        loading: false
      }));
      return data;
    } catch (error) {
      console.error('Error updating ingredient:', error);
      set({ error: error.message, loading: false });
      throw error;
    }
  },

  deleteIngredient: async (ingredientId) => {
    set({ loading: true, error: null });
    try {
      await apiClient.delete(`/api/v1/ingredients/${ingredientId}`);
      set(state => ({
        ingredients: state.ingredients.filter(ingredient => ingredient.id !== ingredientId),
        loading: false
      }));
      return { success: true };
    } catch (error) {
      console.error('Error deleting ingredient:', error);
      set({ error: error.message, loading: false });
      throw error;
    }
  }
}));

export default useIngredientStore;